import * as React from 'react';
import './FullscreenLoadingComponent.css';

import {t} from 'react-multi-lang';

class FullscreenLoadingComponent extends React.PureComponent {
    public render() {
        return (
            <div className="w_fullscreen_loading_component">
                <div className="w_center_container">
                    <h1>
                        {t('loading.loading')}
                    </h1>
                </div>
            </div>
        );
    }
}

export default FullscreenLoadingComponent;


// WEBPACK FOOTER //
// ./src/components/FullscreenLoadingComponent/FullscreenLoadingComponent.tsx